import {
	getArticleCardSuccess,
	likeItemSuccess as likeArticleCardSuccess,
	requestStart as articleCardRequestStart,
	requestFailure as articleCardRequestFailure,
} from './../magazine/article/articlecard';
import {
	getOutfitCardSuccess,
	likeItemSuccess as likeOutfitCardSuccess,
	requestStart as outfitCardRequestStart,
	requestFailure as outfitCardRequestFailure,
} from './../outfit/outfitcard';
import {
	getProductsSuccess as getProductsSearchSuccess,
	likeItemSuccess as likeProductSearchSuccess,
	likeRequestStart as productSearchResultsLikeRequestStart,
	likeRequestFailure as productSearchResultsRequestLikeFailure,
} from './../search/productsearchresults';
import {
	getProductCardSuccess,
	likeItemSuccess as likeProductCardSuccess,
	requestStart as productCardRequestStart,
	requestFailure as productCardRequestFailure,
} from './../product/productcard';
import {
	getProductsSuccess,
	likeItemSuccess as likeProductsSuccess,
	likeRequestStart as productsLikeRequestStart,
	likeRequestFailure as productsLikeRequestFailure,
} from './../product/products';
import {
	getSuccess as getYouMayAlsoLikeProductsSuccess,
	likeItemSuccess as likeYouMayAlsoLikeProductCardSuccess,
	likeRequestStart as youMayAlsoLikeProductsLikeRequestStart,
	likeRequestFailure as youMayAlsoLikeProductsLikeRequestFailure,
} from './../product/youmayalsolike';
import {
	getWardrobeItemsSuccess as getWardrobeItemsSearchSuccess,
	likeItemSuccess as likeWardrobeItemSuccess,
	likeRequestStart as wardrobeItemSearchResultsLikeRequestStart,
	likeRequestFailure as wardrobeItemLikeRequestFailure,
} from './../search/wardrobeitemsearchresults';
import {
	getWishlistSuccess,
	likeItemSuccess as wishlistLikeItemSuccess,
	likeRequestStart as wishlistLikeRequestStart,
	likeRequestFailure as wishlistLiekRequestFailure,
} from './../user/wishlist';
import {
	getOutfitsSuccess,
	likeItemSuccess as likeOutfitsItemSuccess,
	likeRequestStart as outfitsLikeRequestStart,
	likeRequestFailure as outfitsLikeRequestFailure,
} from './../outfit/outfits';
import {
	getWardrobeItemCardSuccess,
	likeItemSuccess as likeWardrobeItemCardSuccess,
	requestStart as wardrobeItemCardRequestStart,
	requestFailure as wardrobeItemCardRequestFailure,
} from './../wardrobe/wardrobeitemcard';

import {
	requestStart as likeArticleRequestStart,
	requestFailure as likeArticleRequestFailure,
	getArticleCommentsSuccess,
} from './../magazine/article/articlecomments';

import { IStore } from 'redux/IStore';
import { ILikedItem, IEntityDto } from 'models/common';
import { LikeNodeType } from 'models/enums/nodetype/likenodetype';
import { NodeType } from 'models/enums/nodetype/nodetype';
import {
	userFeedLikeItemSuccess,
	userFeedLikeRequestStart,
	userFeedLikeRequestFailure,
	getUserFeedItemsSuccess,
} from './userfeed';
import { INotification } from 'models/notifications/notification';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';
import { likeArticleCommentSuccess } from '../magazine/article/articlecomments';

export class Likes {
	private likeNodeType: LikeNodeType;
	private nodeType: NodeType;
	private likeItemSuccess: () => void;
	private requestStart: () => void;
	private requestFailure: (message: any) => void;
	private updateItemsSuccess: (items: any) => void;

	constructor(likeNodeType: LikeNodeType) {
		this.likeNodeType = likeNodeType;

		switch (this.likeNodeType) {
			case LikeNodeType.ArticleCard:
				this.likeItemSuccess = likeArticleCardSuccess;
				this.requestStart = articleCardRequestStart;
				this.requestFailure = articleCardRequestFailure;
				this.updateItemsSuccess = getArticleCardSuccess;
				this.nodeType = NodeType.Article;
				break;
			case LikeNodeType.Outfit:
				this.likeItemSuccess = likeOutfitsItemSuccess;
				this.requestStart = outfitsLikeRequestStart;
				this.requestFailure = outfitsLikeRequestFailure;
				this.updateItemsSuccess = getOutfitsSuccess;
				this.nodeType = NodeType.Outfit;
				break;
			case LikeNodeType.OutfitCard:
				this.likeItemSuccess = likeOutfitCardSuccess;
				this.requestStart = outfitCardRequestStart;
				this.requestFailure = outfitCardRequestFailure;
				this.updateItemsSuccess = getOutfitCardSuccess;
				this.nodeType = NodeType.Outfit;
				break;
			case LikeNodeType.ProductSearch:
				this.likeItemSuccess = likeProductSearchSuccess;
				this.requestStart = productSearchResultsLikeRequestStart;
				this.requestFailure = productSearchResultsRequestLikeFailure;
				this.updateItemsSuccess = getProductsSearchSuccess;
				this.nodeType = NodeType.Product;
				break;
			case LikeNodeType.ProductCard:
				this.likeItemSuccess = likeProductCardSuccess;
				this.requestStart = productCardRequestStart;
				this.requestFailure = productCardRequestFailure;
				this.updateItemsSuccess = getProductCardSuccess;
				this.nodeType = NodeType.Product;
				break;
			case LikeNodeType.Product:
				this.likeItemSuccess = likeProductsSuccess;
				this.requestStart = productsLikeRequestStart;
				this.requestFailure = productsLikeRequestFailure;
				this.updateItemsSuccess = getProductsSuccess;
				this.nodeType = NodeType.Product;
				break;
			case LikeNodeType.ProductsYouMayAlsoLike:
				this.likeItemSuccess = likeYouMayAlsoLikeProductCardSuccess;
				this.requestStart = youMayAlsoLikeProductsLikeRequestStart;
				this.requestFailure = youMayAlsoLikeProductsLikeRequestFailure;
				this.updateItemsSuccess = getYouMayAlsoLikeProductsSuccess;
				this.nodeType = NodeType.Product;
				break;
			case LikeNodeType.WardrobeItemSearch:
				this.likeItemSuccess = likeWardrobeItemSuccess;
				this.requestStart = wardrobeItemSearchResultsLikeRequestStart;
				this.requestFailure = wardrobeItemLikeRequestFailure;
				this.updateItemsSuccess = getWardrobeItemsSearchSuccess;
				this.nodeType = NodeType.WardrobeItem;
				break;
			case LikeNodeType.WardrobeItemCard:
				this.likeItemSuccess = likeWardrobeItemCardSuccess;
				this.requestStart = wardrobeItemCardRequestStart;
				this.requestFailure = wardrobeItemCardRequestFailure;
				this.updateItemsSuccess = getWardrobeItemCardSuccess;
				this.nodeType = NodeType.WardrobeItem;
				break;
			case LikeNodeType.Wishlist:
				this.likeItemSuccess = wishlistLikeItemSuccess;
				this.requestStart = wishlistLikeRequestStart;
				this.requestFailure = wishlistLiekRequestFailure;
				this.updateItemsSuccess = getWishlistSuccess;
				break;
			case LikeNodeType.UserFeed:
				this.likeItemSuccess = userFeedLikeItemSuccess;
				this.requestStart = userFeedLikeRequestStart;
				this.requestFailure = userFeedLikeRequestFailure;
				this.updateItemsSuccess = getUserFeedItemsSuccess;
				break;
			case LikeNodeType.ArticleComment: // TODO: not yet tested
				this.likeItemSuccess = likeArticleCommentSuccess;
				this.requestStart = likeArticleRequestStart;
				this.requestFailure = likeArticleRequestFailure;
				this.updateItemsSuccess = getArticleCommentsSuccess;
				break;
			default:
		}
	}

	public updateLikeItems(likeItems?: any) {
		return (dispatch, getState: () => IStore) => {
			// update array of items
			if (this.isArrayNode()) {
				this.updateArrayOfItems(likeItems, getState(), dispatch);
				// update object
			} else {
				this.updateObject(likeItems, getState(), dispatch);
			}
		};
	}

	public likeArticleComment(commentId: string) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			dispatch(this.updateLikedComment(commentId, undefined));

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Article/' + commentId + '/LikeArticleComment',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'POST',
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.likeItemSuccess());
						dispatch(this.updateLikedComment(commentId, true));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public likeItem(itemId: string, nodeType?: NodeType) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			let type = this.nodeType;
			if (nodeType !== undefined) {
				type = nodeType;
			}
			dispatch(this.updateLikedItem(itemId, undefined));

			return fetch(
				getState().fetchDefault.baseAPI + 'api/' + NodeType[type] + '/' + itemId + '/Like',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'POST',
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.likeItemSuccess());
						dispatch(this.updateLikedItem(itemId, true));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public unlikeArticleComment(itemId: string) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());
			dispatch(this.updateLikedComment(itemId, undefined));

			return fetch(
				getState().fetchDefault.baseAPI + 'api/Article/' + itemId + '/LikeArticleComment',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'DELETE',
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.likeItemSuccess());
						dispatch(this.updateLikedComment(itemId, false));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public unlikeItem(itemId: string, nodeType?: NodeType) {
		return (dispatch, getState: () => IStore) => {
			dispatch(this.requestStart());

			let type = this.nodeType;
			if (nodeType !== undefined) {
				type = nodeType;
			}
			dispatch(this.updateLikedItem(itemId, undefined));

			return fetch(
				getState().fetchDefault.baseAPI + 'api/' + NodeType[type] + '/' + itemId + '/Like',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'DELETE',
				}),
			)
				.then((res) => {
					if (res.ok || res.status === 409) {
						dispatch(this.likeItemSuccess());
						dispatch(this.updateLikedItem(itemId, false));
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					dispatch(this.requestFailure(err));
				});
		};
	}

	public getLikedItems(items?: IEntityDto[]) {
		return (dispatch, getState: () => IStore) => {
			if (!accessTokenIsPresent()) {
				return Promise.resolve(false);
			}

			dispatch(this.requestStart());

			const data = this.getNodeItems(getState());
			let itemsToGet = null;
			if (!items && this.isArrayNode()) {
				items = data.map((item) => {
					return {
						entityId: item.entityId,
					};
				});
			}
			if (items) {
				if (!items.length) {
					return;
				}
				itemsToGet = JSON.stringify(items);
			} else {
				itemsToGet = JSON.stringify([{ entityId: data.entityId }]);
			}

			return fetch(
				getState().fetchDefault.baseAPI + 'api/User/Likes',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'POST',
					body: itemsToGet,
				}),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res) => {
							if (this.isArrayNode()) {
								dispatch(this.updateLikeItems(res));
							} else {
								dispatch(this.updateLikeItems(res[0]));
							}
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(this.requestFailure(res));
							})
							.catch((err) => {
								console.error(err);
								const message: any = { status, statusText };
								dispatch(this.requestFailure(message));
							});
					}
				})
				.catch((err) => {
					console.error(err);
					dispatch(this.requestFailure(err));
				});
		};
	}

	private updateLikedItem(itemId: string, liked: true | false | undefined) {
		return (dispatch, getState: () => IStore) => {
			const data = this.getNodeItems(getState());
			if (!data) {
				return;
			}

			if (liked === undefined) {
				dispatch(this.updateItemsSuccess(data));
				return;
			}

			// update array of items
			if (this.isArrayNode()) {
				const itemInList = this.getItem(data, itemId);
				const itemIndex = data.indexOf(itemInList);
				if (itemIndex > -1) {
					data[itemIndex].isLiked = liked;
					dispatch(this.updateItemsSuccess(data));
				}
				// update object
			} else {
				data.isLiked = liked;
				if (data.likesCount !== undefined) {
					data.likesCount = data.likesCount + (liked ? 1 : -1);
				}
				dispatch(this.updateItemsSuccess(data));
			}
		};
	}

	private updateLikedComment(commentId: string, liked: true | false | undefined, initialStateSet?: boolean) {
		return (dispatch, getState: () => IStore) => {
			const data = this.getNodeItems(getState());
			if (!data) {
				return;
			}

			if (liked === undefined) {
				dispatch(this.updateItemsSuccess(data));
				return;
			}

			if (initialStateSet && data instanceof Array) {
				// we just set the initial liked state of the comments
				data.forEach((item) => {
					if (item.id === commentId) {
						item.isLiked = liked;
					}
				});
				dispatch(this.updateItemsSuccess(data));
				return;
			}

			if (data instanceof Array) {
				const itemInList = data.filter((x) => x.id === commentId)[0];
				const itemIndex = data.indexOf(itemInList);
				if (itemIndex > -1) {
					data[itemIndex].isLiked = liked;
					if (data[itemIndex].likesCount !== undefined) {
						data[itemIndex].likesCount = data[itemIndex].likesCount + (liked ? 1 : -1);
					}
					dispatch(this.updateItemsSuccess(data));
				}
			}
		};
	}

	private getItem(data: any, id: any) {
		return data.filter((i: INotification | IEntityDto) => {
			if (typeof i === 'object' && 'to' in i && i.to.entityId) {
				return JSON.parse(i.to.entityId).id === id;
			} else if ('entityId' in i && i.entityId && i.entityId.length > 0) {
				return JSON.parse(i.entityId).id === id;
			} else if ('id' in i) {
				return i.id === id;
			}
		})[0];
	}

	private updateArrayOfItems(likeItems: ILikedItem[], state: IStore, dispatch: any) {
		const data: any[] = this.getNodeItems(state, true);
		if (likeItems !== null) {
			likeItems.forEach((likeItem: ILikedItem) => {
				const entityId = likeItem.key.entityId;
				const id = JSON.parse(entityId).id;
				const item: any = this.getItem(data, id);
				if (!item) {
					return;
				}
				const itemIndex = data.indexOf(item);
				item.isLiked = likeItem.value;
				if (itemIndex > -1) {
					data[itemIndex] = item;
				}
			});
		} else {
			data.map((item) => {
				item.isLiked = false;
			});
		}
		dispatch(this.updateItemsSuccess(data));
	}

	private updateObject(likedItem: ILikedItem, state: IStore, dispatch: any) {
		const data: any = this.getNodeItems(state, true);
		if (likedItem !== null) {
			if (data.id === JSON.parse(likedItem.key.entityId).id) {
				data.isLiked = likedItem.value;
			}
		} else {
			data.isLiked = false;
		}
		dispatch(this.updateItemsSuccess(data));
	}

	private isArrayNode(): boolean {
		if (
			this.likeNodeType === LikeNodeType.ProductSearch ||
			this.likeNodeType === LikeNodeType.Product ||
			this.likeNodeType === LikeNodeType.ProductsYouMayAlsoLike ||
			this.likeNodeType === LikeNodeType.WardrobeItemSearch ||
			this.likeNodeType === LikeNodeType.Wishlist ||
			this.likeNodeType === LikeNodeType.Outfit ||
			this.likeNodeType === LikeNodeType.UserFeed
		) {
			return true;
		} else {
			return false;
		}
	}

	public isCommentLiked(commentId: string, userId: string) {
		return (dispatch, getState: () => IStore) => {
			return fetch(
				getState().fetchDefault.baseAPI + 'api/Article/' + commentId + '/ArticleCommentLikers',
				Object.assign({}, getState().fetchDefault.requestInit, {
					method: 'GET',
				}),
			).then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						var isLiked = false;
						res.forEach((item) => {
							var id = JSON.parse(item.entityId)?.id;
							if (id === userId) {
								isLiked = true;
							}
						});
						if (isLiked) {
							dispatch(this.updateLikedComment(commentId, isLiked, true));
						}
					});
				} else {
					return Promise.reject(res);
				}
			});
		};
	}

	private getNodeItems(state: IStore, clone?: boolean) {
		let data = null;
		if (this.likeNodeType === LikeNodeType.ArticleCard) {
			data = state.articleCard.item;
		} else if (this.likeNodeType === LikeNodeType.Product) {
			data = state.products.items;
		} else if (this.likeNodeType === LikeNodeType.ProductSearch) {
			data = state.productSearchResults.items;
		} else if (this.likeNodeType === LikeNodeType.ProductCard) {
			data = state.productCard.productCard;
		} else if (this.likeNodeType === LikeNodeType.ProductsYouMayAlsoLike) {
			data = state.youMayAlsoLikeProducts.items;
		} else if (this.likeNodeType === LikeNodeType.Wishlist) {
			data = state.wishlist.items;
		} else if (this.likeNodeType === LikeNodeType.Outfit) {
			data = state.outfits.items;
		} else if (this.likeNodeType === LikeNodeType.OutfitCard) {
			data = state.outfitCard.outfitCard;
		} else if (this.likeNodeType === LikeNodeType.WardrobeItemCard) {
			data = state.wardrobeItemCard.wardrobeItemCard;
		} else if (this.likeNodeType === LikeNodeType.WardrobeItemSearch) {
			data = state.wardrobeItemSearchResults.items;
		} else if (this.likeNodeType === LikeNodeType.UserFeed) {
			data = state.userFeed.items;
		} else if (this.likeNodeType === LikeNodeType.ArticleComment) {
			data = state.articleComments.comments;
		}
		if (clone) {
			return JSON.parse(JSON.stringify(data));
		}
		return data;
	}
}
